








































import { Component, Vue } from 'vue-property-decorator';
import TranscriptionEvent from '@/components/home/TranscriptionEvent.vue';
import TaggingEvent from '@/components/home/TaggingEvent.vue';

import { getModule } from 'vuex-module-decorators';
import { db } from '@/plugins/firebase';
import Profile from '@/components/Profile.vue';
import store from '@/store/store';
import Auth from '@/store/modules/auth';
import { auth } from 'firebase';
import LeaderBoard from '@/components/home/LeaderBoard.vue';
import PersonalHistory from '@/components/home/PersonalHistory.vue';
import Dialog from '@/store/modules/dialog';
const authModule = getModule(Auth, store);
const dialogModule = getModule(Dialog, store);
@Component({
  components: {
    TranscriptionEvent,
    TaggingEvent,
    Profile,
    LeaderBoard,
    PersonalHistory,
  },
  firestore: {
    events: db
      .collection('timeline')
      .where('share', '==', true)
      .limit(30)
      .orderBy('timestamp', 'desc'),
    news: db.collection('news').orderBy('timestamp', 'desc').limit(5),
  },
})
export default class Home extends Vue {
  events: any = [];
  news: any = [];

  openTutorial() {
    dialogModule.toggleTutorialDialog({ open: true });
  }

  title() {
    return 'ホーム';
  }

  showLikers(likerUids: Array<string>) {
    console.log(likerUids);
  }

  get newsHTML() {
    return this.news.map((n) => `<p><b>${n.id}</b>　${n.text}</p>`).join('');
  }

  get user() {
    return authModule.user;
  }
  async created() {
    // const snapshot = await db
    //   .collection('timeline')
    //   .where('share', '==', true)
    //   .limit(50)
    //   .orderBy('timestamp', 'desc')
    //   .get();
    // snapshot.forEach((doc) => {
    //   const data = doc.data();
    //   data.id = doc.id;
    //   this.events.push(data);
    // });
    // console.log(this.events);
  }

  jumpToForm() {
    const uid = authModule.user ? authModule.user.uid : '';
    const form = `https://docs.google.com/forms/d/e/1FAIpQLSfLmnjbxUwJpeBcGLl1xAKkxEcqh5mv7bIGw6_elxfjdgSMQw/viewform?entry.1359268108=${uid}`;
    window.open(form, '_blank');
  }
}
